import { Link } from 'react-router-dom';
import GameCard from '@/components/feature/GameCard';
import { newGames } from '@/mocks/games';

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              刚上架的Galgame资源，第一时间体验
            </p>
          </div>
          <Link
            to="/category/xinyou"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            更多新作
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {newGames.slice(0, 6).map((game) => (
            <GameCard key={game.id} {...game} />
          ))}
        </div>
      </div>
    </section>
  );
}